import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import {config} from './config';

firebase.initializeApp(config);

const firebaseDatabase = firebase.firestore();
const firebaseAuth = firebase.auth();
const firebaseStorage = firebase.storage();

export {
    firebaseDatabase,
    firebaseAuth,
    firebaseStorage,
}